// No imports: the designer page bundles this file too, so the browser and the server check contact details alike.

export const CONTACT_LIMITS = { name: 200, email: 320, phone: 40, business: 200, note: 500 } as const;

// Optional phone: digits with + ( ) . - and spaces, at least 7 digits, and an optional "x 12" or "ext. 12".
const PHONE_RE = /^[+()0-9.\-\s]{7,30}(\s*(x|ext\.?)\s*\d{1,6})?$/i;
const EXTENSION_RE = /\s*(x|ext\.?)\s*\d{1,6}$/i;

export function phoneOk(phone: string): boolean {
  const p = phone.trim();
  // The 7 digits are counted before the extension: "555-010 x 1234" is not a phone number.
  return p === "" || (p.length <= CONTACT_LIMITS.phone && PHONE_RE.test(p) && (p.replace(EXTENSION_RE, "").match(/\d/g) ?? []).length >= 7);
}

// A shipping address the order can go out on: a street, city, state and ZIP, each filled and at most 200 characters.
// Client orders (src/lib/order-insert.ts) and design checkouts (src/api/checkout.ts) both check it.
export const SHIP_ADDRESS_REQUIRED = ["line1", "city", "state", "zip"] as const;
export function shipAddressComplete(a: Record<string, unknown> | null | undefined): boolean {
  return !!a && SHIP_ADDRESS_REQUIRED.every((k) => typeof a[k] === "string" && (a[k] as string).trim() !== "" && (a[k] as string).length <= 200);
}
